import React, { useContext } from 'react';
import { Heading, HeadingLevel } from 'baseui/heading';
import { ProjectStatusEnum } from '@gtintel/platform-types';
import AttachmentFiles from '../components/AttachmentFiles';
import Documents from '../components/Documents';
import { ProjectContext } from './context';
import { LegacyDocumentsContainer } from './legacy/Documents';
export default ({
  isUserNP,
  canViewAllAttachments
}) => {
  const projectCtx = useContext(ProjectContext);
  const canUpload = isUserNP ? [ProjectStatusEnum.ACTIVATED, ProjectStatusEnum.COMPLETED].includes(parseInt(projectCtx.status())) : true;
  return <React.Fragment>
      {canViewAllAttachments && <AttachmentFiles isNP={isUserNP} />}

      <HeadingLevel>
        <Heading styleLevel={2}>Project Documents</Heading>
      </HeadingLevel>

      <Documents canUpload={canUpload} />

      <LegacyDocumentsContainer id={projectCtx.projectId()} />
    </React.Fragment>;
};